import { useState } from "react";
import { Loader2, Music2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { FolderSection } from "@/components/FolderSection";

/* FileJump folders scanned for music. Empty = the whole music root (the original behaviour). "Scan music folders" imports only these. */
export const MusicFolders = ({ creds, running, onStarted }) => {
  const [busy, setBusy] = useState(false);
  const scan = async () => {
    setBusy(true);
    try { await api.post("/webdav/sync", null, { params: { scope: "music" } }); onStarted?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <FolderSection id="music-folders" testid="music-folders" creds={creds} endpoint="/webdav/music-folders"
      icon={<Music2 size={14} />} title="Music folders"
      description="Only these folders are read when you scan for music; leave the list empty to scan your whole music root. Audiobook folders are kept separate."
      scanButton={(
        <button onClick={scan} disabled={busy || running} data-testid="music-folders-scan" data-running={running ? 1 : 0} title="Look for new or changed music files in these folders" className="flex !h-8 items-center gap-2 rounded-full border border-zinc-300 bg-white px-3 text-xs font-medium hover:border-zinc-900 disabled:opacity-60">
          {busy || running ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}{running ? "Scanning…" : "Scan music folders"}
        </button>
      )}
      onSaved={(data, picked) => {
        toast.success(data.folders.length ? `Music folders saved — ${data.folders.length} folder${data.folders.length === 1 ? "" : "s"}` : "Music folders cleared — the whole music root will be scanned");
        if (data.outside_root?.length && picked.length) toast.message("This folder is outside your music root", { description: "Press “Scan music folders” to import its files." });
      }} />
  );
};
